import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import { useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Header.module.scss";

function AuthorizedPrimaryNavigation({ loggedIn }) {
  if (!loggedIn) return null;
  return (
    <ScrollMenu className={styles.primaryNavigationInner}>
      <ActiveLink className={styles.menuContLink} href={routes.home}>
        <span>ホーム</span>
      </ActiveLink>
      <ActiveLink
        className={styles.menuContLink}
        href={routes.myList}
        matchtype="partial"
      >
        <span>マイリスト</span>
      </ActiveLink>
    </ScrollMenu>
  );
}
function NotAuthorizedPrimaryNavigation({ loggedIn }) {
  if (loggedIn) return null;
  return (
    <ScrollMenu className={styles.primaryNavigationInner}>
      <ActiveLink className={styles.menuContLink} href={routes.home}>
        <span>ホーム</span>
      </ActiveLink>
    </ScrollMenu>
  );
}
// export default memo(PrimaryNavigation);
export default function PrimaryNavigation() {
  const { loading, data } = useAuthUserQuery({ fetchPolicy: "cache-first" });
  const loggedIn = !loading && data?.user;

  return (
    <div className={styles.primaryNavigation}>
      <NotAuthorizedPrimaryNavigation loggedIn={loggedIn} />
      <AuthorizedPrimaryNavigation loggedIn={loggedIn} />
    </div>
  );
}
